import request from '@/utils/request'

const PREFIX = '/signstore/showData'

/** 默认活动编码（与后台配置一致，可通过 query 覆盖） */
export const SHOW_DATA_DEFAULT_ACTIVITY_CODE = 'ad1f0fe16edd418f'

/**
 * 分页查询参与用户（手机号非空，按 yx_user 创建时间倒序）
 * @param {{ activityCode?: string, page?: number, size?: number }} params
 */
export function fetchShowDataParticipants(params) {
  return request.get(PREFIX + '/participants', { params })
}
